import * as actionTypes from '../actions/actionTypes';

const initialState = {
  order: {},
  cards: [],
  availableTeamVouchers: [],
  availableTeamVouchersTotal: 0,
  availableTeamVouchersLastExpiryDate: undefined,
  idOrder: undefined,
  showModalReceipt: false,
  showModalConfirmEmails: false,
  showModalPlaceOrder: false,
  showModalError: false,
  campaignRateCC: {},
  payInfo: {},
  errorMessage: undefined,
  errorType: undefined,
  voucherBalance: [],
};

const teamVoucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TEAM_VOUCHER_SUCCESS_FETCHING_CARDS:
      return {
        ...state,
        cards: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_SET_ORDER:
      return {
        ...state,
        order: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_SET_CAMPAIGN_RATE:
      return {
        ...state,
        campaignRateCC: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_SET_PAY_INFO:
      return {
        ...state,
        payInfo: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER:
      return {
        ...state,
        availableTeamVouchers: action.payload,
        availableTeamVouchersTotal: action.payload
          .map(tv => tv.value)
          .reduce((sum, current) => sum + current, 0),
        availableTeamVouchersLastExpiryDate: 0,
      };
    case actionTypes.TEAM_VOUCHER_SUCCESS_PLACE_ORDER:
      return {
        ...state,
        order: {
          ...state.order,
          idOrder: action.payload.idOrder,
          publicOrderNumber: action.payload.publicOrderNumber,
          idBusinessRestaurant: action.payload.idBusinessRestaurant,
        },
      };
    case actionTypes.TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER:
      return {
        ...state,
        showModalPlaceOrder: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT:
      return {
        ...state,
        showModalReceipt: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS:
      return {
        ...state,
        showModalConfirmEmails: true,
      };
    case actionTypes.TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS:
      return {
        ...state,
        showModalConfirmEmails: false,
      };
    case actionTypes.TEAM_VOUCHER_OPEN_MODAL_ERROR:
      return {
        ...state,
        showModalError: true,
        errorMessage: action.payload.errorMessage,
        errorType: action.payload.errorType,
        errorObject: action.payload.errorObject,
      };
    case actionTypes.TEAM_VOUCHER_CLOSE_MODAL_ERROR:
      return {
        ...state,
        showModalError: false,
        errorMessage: undefined,
        errorType: undefined,
        errorObject: undefined,
      };
    case actionTypes.VOUCHER_BALANCE_SUCCESS:
      return {
        ...state,
        voucherBalance: action.payload,
      };
    case actionTypes.TEAM_VOUCHER_RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default teamVoucherReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/teamVoucherReducer.js